import React from 'react'

export const InfoRow: React.FC<{
  name: string
  value: string
  bottomRow?: boolean
}> = ({ name, value, bottomRow }) => {
  return (
    <div
      className={`d-flex justify-content-between  ${
        bottomRow ? 'pt-3' : 'py-3 border-bottom'
      }`}
    >
      <span className="d-inline-block">{name}</span>
      <span className="d-inline-block text-muted">{value}</span>
    </div>
  )
}
